import { z } from 'zod'

export const bulkAnswerSchema = z.object({
  document_number: z.string(),
  bulk_answer: z.string().nullable(),
})

export const bulkChatHistorySchema = z.object({
  answers: z.array(bulkAnswerSchema),
})

export type BulkAnswer = z.infer<typeof bulkAnswerSchema>
export type BulkChatHistory = z.infer<typeof bulkChatHistorySchema>
